// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__10uwD","chartBlock":"Chart_chartBlock__3MOk4","actions":"Chart_actions__20BCK","btn":"Chart_btn__1LIYv","editBtn":"Chart_editBtn__3t7u7"};